import Axios from 'axios';

export class Payload {
    constructor(endpoint, method, payload) {
        this.endpoint = endpoint
        this.method = method, // GET, POST, PUT, DELETE
            this.payload = payload || {}
        this.headers = []
    }
    withCredentials(key, value) {
        this.headers.push({ key, value })
    }
}
export const apiProxy = (options) => {
    try {
        return Axios.post('/ProxyApi', options);
    } catch (error) {
        throw new Error(error);
    }
};